import axios from "axios";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "./Utility";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const sendChatMessage = async (service, message, files) => {
  if (!service) {
    throw new Error("No AI service selected");
  }

  const formData = new FormData();

  const payload = {
    message,
    hasFile: files?.length > 0 ? true : false,
  };
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    SECRET_KEY
  ).toString();
  formData.append("payload", encryptedData);

  // if (message) {
  //   formData.append("message", message);
  // }

  if (files && files.length > 0) {
    formData.append("image", files[0], files[0].name);
  }

  let endpoint = "";
  switch (service.toLowerCase()) {
    case "chatgpt":
      endpoint = `${BASE_URL}/user/gptChat`;
      break;
    case "perplexity":
      endpoint = `${BASE_URL}/user/pplxChat`;
      break;
    case "bedrock":
      endpoint = `${BASE_URL}/user/bedrockChat`;
      break;
    default:
      throw new Error(`Unknown AI service selected: ${service}`);
  }

  try {
    const res = await axios.post(endpoint, formData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });

    const encrypted = res.data;
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decrypted
  } catch (error) {
    console.error("Chat API Error:", error);
    throw error.response?.data || error.message;
  }
};
